import { useId } from "react"

import { Invoice } from "@/types/invoice"
import { formatAmount, formatDateShort } from "@/lib/utils"
import { Button as UiKitButton } from "@/components/ui-kit/button"
import { CreditCardIcon } from "@/components/icons"

export function UnpaidInvoicesLine({
  invoice,
  onPay,
}: {
  invoice: Invoice
  onPay: () => void
}) {
  const nameId = useId()

  return (
    <div role="group" aria-labelledby={nameId} className="flex flex-col gap-4 my-4">
      <div className="flex flex-col gap-1">
        <span id={nameId} className="text-lg leading-6">{invoice.name}</span>
        <div className="flex items-center justify-between gap-4">
          <span className="text-lg leading-6 font-medium">{formatAmount(invoice.total ?? invoice.amount)}</span>
          <span className="text-lg leading-6 text-muted-foreground">
            от {formatDateShort(invoice.createdAt)}
          </span>
        </div>
      </div>
      <UiKitButton
        type="button"
        variant="secondary"
        className="w-full sm:h-[60px] bg-background text-foreground h-[48px] sm:text-lg text-[16px] leading-6"
        endIcon={<CreditCardIcon size={24} className="size-[24px]" />}
        onClick={onPay}
      >
        Оплатить
      </UiKitButton>
    </div>
  )
}
